import 'select2/dist/js/select2';

export default class Select2 {

	constructor() {
		this.bindUIActions();
	}

	applySelect2Styles() {
		const select2Options = {
			minimumResultsForSearch: Infinity, // Hide the search box
			width: 'resolve'
		};

		$('.js-select2').select2(select2Options);
		$('.select2-container').css('width', '100%');
	}

	bindUIActions() {
		// Apply Select2 styles on page load
		this.applySelect2Styles();

		// Add a method to reinitialize Select2 styles after form submission
		this.handleFormEvents();
	}

	handleFormEvents() {
		// Listen for both 'submit' and 'gform_post_render' events and re-apply Select2 styles
		$(document).on('submit gform_post_render', () => {
			this.applySelect2Styles();
		});
	}
}

new Select2();
